import { useDispatch, useSelector } from "react-redux";
import { toast, Notification } from "components/ui";
import {
    selectState,
    selectOptions,
    hideMessage,
} from "store/base/messageSlice";
import { useEffect } from "react";

const ThemeMessage = (props) => {
    const dispatch = useDispatch();
    const state = useSelector(selectState);
    const options = useSelector(selectOptions);

    useEffect(() => {
        if (state) {
            toast.push(
                <Notification
                    type={options.type}
                    duration={options.duration}
                    title={options.title}
                    closable={options.closable}
                    onClose={() => dispatch(hideMessage())}
                >
                    {options.message}
                </Notification>,
                {
                    placement: options.position,
                }
            );
        }
    }, [dispatch, options, state]);
    return null;
};

export default ThemeMessage;
